import React from 'react';
import Tabs from './tabs';
import Modal from '../Modal';

const ConditionsPopin = ({ popInConditions, handleConditionsPopin }) => {
  return (
    <Modal closeModalHandler={handleConditionsPopin} closeBtn>
      <Tabs popInConditions={popInConditions} />
    </Modal>
  );
};

export default ConditionsPopin;
